export default "__VITE_ASSET__4bfdae8e__"